import React from "react";

export const PageHeader = ({ eyebrow, title, lead }) => (
  <section className="relative overflow-hidden bg-background border-b border-[hsl(var(--border))]">
    <div className="absolute inset-0 hero-wash pointer-events-none" aria-hidden="true" />
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div className="container-wide relative py-14 lg:py-20 max-w-4xl">
      {eyebrow && <div className="eyebrow"><span className="inline-block h-1.5 w-6 rounded-full bg-[hsl(var(--green))]" /> {eyebrow}</div>}
      <h1 className="heading-1 mt-3 text-4xl sm:text-5xl">{title}</h1>
      {lead && <p className="lead mt-4 max-w-3xl">{lead}</p>}
    </div>
  </section>
);
